import "./App.scss";
import AppRouter from "./routes/AppRouter";

function App() {
  return (
    <div className="wrapper">
      <AppRouter />
    </div>
  );
}

export default App;
